import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import React from "react";
import { formatTime, formatWrittenDayMonthYear } from "utilities";
import { ArtistSidePanel } from "../Company/CompanySidePanel";
import { SidePanelContactList } from "../contact/SidePanelContactList";
import AppointmentPhase from "components/Atoms/AppointmentPhase";
import { SidePanelDepartureArrival } from "../details/SidePanelDepartureArrival";
import { JourneySegment } from "components/Atoms/JourneySegment";

interface TrainSidePanelDetailsProps {
  trainSegmentId: number
  train: server.dto.Train
}

export const TrainSidePanelDetails = (props: TrainSidePanelDetailsProps) => {
  const { train } = props;

  const trainSegment = train.segments.find(segment => segment.id === props.trainSegmentId);

  const startDateWritten = formatWrittenDayMonthYear(trainSegment.start.dateTimeLocal);
  const endDateWritten = formatWrittenDayMonthYear(trainSegment.end.dateTimeLocal);

  const startTimeWritten = formatTime(trainSegment.start.dateTimeLocal);
  const endTimeWritten = formatTime(trainSegment.end.dateTimeLocal);

  return <SidePanelDetailSectionTemplate
    isInPageEditable={false}
    onValueChanged={() => { }}
    fields={[{
      key: "artist",
      label: site.currentEnvironment.functionGroups.artist.singular,
      isEmpty: !train.artist,
      render: () => <ArtistSidePanel
        companyId={train.artist.artistId}
        trigger={<a>{train.artist.name}</a>}
        fallbackIfNoPermission={<>{train.artist.name}</>}
      />
    }, {
      key: "travellers",
      label: RESX.Flight.Travellers,
      isEmpty: train.travellers.length === 0,
      render: () => <SidePanelContactList contacts={train.travellers} />
    }, {
      key: "status",
      label: RESX.Status.resxStatus,
      render: () => <AppointmentPhase value={train.phase} displayLabel />
    }, {
      key: "departureArrival",
      label: "",
      hideLabel: true,
      render: () => <>
        <SidePanelDepartureArrival
          dateWritten={startDateWritten}
          timeWritten={startTimeWritten}
          addressLine1={trainSegment.start.station.name}
          addressLine2={trainSegment.start.station.address.formatted.join(", ")}
        />

        <JourneySegment
          duration={trainSegment.duration}
          distance={trainSegment.distance}
        />

        <SidePanelDepartureArrival
          dateWritten={endDateWritten !== startDateWritten ? endDateWritten : undefined}
          timeWritten={endTimeWritten}
          addressLine1={trainSegment.end.station.name}
          addressLine2={trainSegment.end.station.address.formatted.join(", ")}
        />
      </>
    }, {
      key: "trainNumber",
      label: RESX.Train.TrainNumber,
      isEmpty: !trainSegment.trainNumber,
      render: () => <span>{trainSegment.trainNumber}</span>
    }, {
      key: "seats",
      label: RESX.Flight.Seats,
      isEmpty: !trainSegment.seats,
      render: () => <span>{trainSegment.seats}</span>
    }, {
      key: "bookingCode",
      label: RESX.Flight.BookingCode,
      isEmpty: !train.bookingCode,
      render: () => <span>{train.bookingCode}</span>
    }]}
  />
}